var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hooper',{attrs:{"settings":_vm.hooperSettings}},_vm._l((_vm.brandList),function(brand,i){return _c('slide',{key:i},[_c('LazyImage',{staticClass:"brand-logo",attrs:{"src":brand.src,"alt":"brand"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }